import { Typography,Empty } from 'antd';

export default function UploadEmpty(){
    return(
        <div style={{paddingTop: "2em"}}>
            <Typography.Title level={1}>Upload Zone</Typography.Title>
            <Empty description="Het lijkt erop dat U geen rechten heeft om zaken te uploaden. Contacteer de administrator om rechten aan te vragen."/>
        </div>
    )
}